import { Component, Inject, Input, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { EventLog } from 'src/app/common/interfaces/tree-node.interface';
import { WarrantiesService } from '../../service/warranties.service';

@Component({
  selector: 'app-modal-eventos',
  templateUrl: './modal-eventos.component.html',
  styleUrls: ['./modal-eventos.component.scss'],
})
export class ModalEventosComponent {
  displayedColumns: string[] = ['date', 'message'];
  // dataSource = new MatTableDataSource<EventLog>(this.data);
  public tableDataSource: MatTableDataSource<any>;
  public boolean: boolean = false;
  @ViewChild(MatSort) sort: MatSort;
  public dataSource: MatTableDataSource<EventLog>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private eventLogService: WarrantiesService
  ) {
    this.tableDataSource = new MatTableDataSource([]);
  }

  ngOnInit(): void {
    this.dataSource = this.data;

    this.consulta(this.data);
    this.dataSource = new MatTableDataSource([]);
    this.setDataSource();
  }

  consulta(warrantyId: number) {
    this.boolean = true;
    this.eventLogService.getEventLogs(warrantyId).subscribe({
      next: (e) => {     
        this.dataSource = e;        
      },
      complete: () => {
        this.boolean = false
      },
    });
    
  }
  private setDataSource() {
    this.dataSource.data = this.data;
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
}
